import React, { createContext, useState, useContext } from 'react';

// Create context for the language
const LanguageContext = createContext();

// Create a provider component
export const LanguageProvider = ({ children }) => {
 
  // Detect browser language
  const browserLang = navigator.language || navigator.userLanguage || 'fr';

  // If browser language starts with 'fr', use 'FR', else use 'EN'
  const initialLang = browserLang.toLowerCase().startsWith('fr') ? 'FR' : 'EN';

  const [language, setLanguage] = useState(initialLang);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook to use language context
export const useLanguage = () => {
  return useContext(LanguageContext);
};
